import { Badge } from "../ui/Badge.js";
import { IconSchool } from "@tabler/icons-react";

const compactBadgeClass = "shrink-0 gap-0.5 whitespace-nowrap border px-1.5 py-0 text-[10px] leading-4";

export const StudentAgreementBadge = () => (
  <Badge variant="info"
    title="Student agreement: payslip hours are doubled for overtime comparison"
    className={`${compactBadgeClass} border-info/40`}
  >
    <IconSchool size={10} stroke={1.8} />
    Student x2
  </Badge>
);

export const validWorkloadBadgePercent = (percent?: number | null) => {
  if (typeof percent !== "number") return null;
  return (
    [50, 75, 100].find(
      (allowedPercent) => Math.abs(percent - allowedPercent) < 0.01,
    ) ?? null
  );
};

export const WorkloadBadge = ({
  percent,
  student = false,
}: {
  percent?: number | null;
  student?: boolean;
}) => {
  const displayPercent = validWorkloadBadgePercent(percent);
  if (displayPercent === null || displayPercent === 100) return null;
  const title = `Effective workload for this month: ${displayPercent}%`;
  const content = (
    <>
      {student && <IconSchool size={10} stroke={1.8} />}
      {displayPercent}%
    </>
  );
  const className =
    `${compactBadgeClass} border-success/40 font-semibold`;

  return (
    <Badge variant="success" title={title} className={className}>
      {content}
    </Badge>
  );
};
